export default __webpack_public_path__ + "static/media/ubuntu-regular.8efd1817.woff";